// Shared "is a voucher form mid-entry?" flag. Voucher entry pages set it as the
// user types; the App-level keymap handlers (F4–F10 voucher switching, Alt+F3
// gateway, Alt+letter reports) read it so an EMPTY form navigates silently and
// a dirty one asks first. Deliberately not React state — it's read inside
// event handlers only.

let dirty = false;

export function setVoucherDirty(v: boolean) {
  dirty = v;
}

export function isVoucherDirty() {
  return dirty;
}
